<template>
  <div class="main-wrapper" :class="[mainWrapperClass]">
    <!---Navigation-->
    <Navbar :topbarColor="topbarColor" :title="logotitle" />
    <!---Sidebar-->
    <SideBar parent=".main-wrapper" />
    <!---Page Container-->
    <div class="main-container-fluid">
      <Breadcrumb />
      <transition
        name="router-anim"
        enter-active-class="fade-enter-active fade-enter"
        leave-active-class="fade-leave-active fade-enter"
      >
        <router-view />
      </transition>
    </div>
    <InactivityModal
      ref="inactivityModal"
      :isActive="showInactivityModal"
      :isTokenWarning="isTokenWarning"
      @logout="handleLogout"
      @continue="handleContinue"
    />
  </div>
</template>

<script>
import { clearSession } from '@/axiosConfig'

import Navbar from '@/layout/full/header/Navbar.vue'
import SideBar from '@/layout/full/sidebar/SideBar.vue'
import Breadcrumb from '@/layout/full/breadcrumb/Breadcrumb.vue'
import themeConfig from '@/../themeConfig.js'
import { InactivityModal } from '@/components/common/InactivityModal'
import { Validator } from 'vee-validate'

export default {
  name: 'MainContainer',
  components: {
    Navbar,
    SideBar,
    Breadcrumb,
    InactivityModal,
  },
  data() {
    return {
      topbarColor: themeConfig.topbarColor,
      logotitle: themeConfig.logotitle,
      isTokenWarning: false,
      showInactivityModal: false, // Controla la visibilidad del modal de inactividad
    }
  },
  mounted() {
    // Escuchar evento global de expiración de token
    window.addEventListener('token-almost-expired', this.showTokenWarningModal)
    
    // Configuración de idioma
    const rawLang = navigator.language || navigator.userLanguage || 'es'
    const browserLanguaje = rawLang.substring(0, 2)
    const lang = this.$route.query.lang || browserLanguaje

    const supportedLanguages = ['es', 'en']
    if (supportedLanguages.includes(lang)) {
      this.$i18n.locale = lang
      Validator.localize(lang)
    } else {
      this.$i18n.locale = 'es'
    }
  },
  beforeDestroy() {
    window.removeEventListener(
      'token-almost-expired',
      this.showTokenWarningModal
    )
  },
  methods: {
    updateTopbarColor(val) {
      this.topbarColor = val
    },
    handleLogout() {
      this.isTokenWarning = false
      clearSession()
      location.href = '/view/login'
    },
    handleContinue() {
      console.log('🔄 Botón "Estoy aquí" presionado')

      // Cerrar el modal
      this.showInactivityModal = false
      this.isTokenWarning = false

      // Limpiar timers del modal si existen
      if (
        this.$refs.inactivityModal &&
        this.$refs.inactivityModal.clearAutoLogout
      ) {
        this.$refs.inactivityModal.clearAutoLogout()
      }

      // Reactivar sistema de sesión completamente
      if (this.$handleContinueModal) {
        this.$handleContinueModal()
      }
    },
    showTokenWarningModal() {
      if (!this.showInactivityModal) {
        this.isTokenWarning = true
        this.showInactivityModal = true
      }
    },
  },
  computed: {
    sidebarWidth: function () {
      return this.$store.state.sidebarWidth
    },
    mainWrapperClass: function () {
      if (this.sidebarWidth == 'default') {
        return 'main-wrapper-default'
      } else if (this.sidebarWidth == 'mini') {
        return 'main-wrapper-mini'
      } else if (this.sidebarWidth) {
        return 'main-wrapper-full'
      }
      return 'default'
    },
  },
}
</script>
